import { render } from "./listView.vue?vue&type=template&id=73ca40ef"
import script from "./listView.vue?vue&type=script&lang=js"
export * from "./listView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gegeheusel/Sites/leica-partnersuche-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__